import React from 'react';
import Navigation from '../../../components/Navigation/Navigation';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';
import AdminPanel from '../../../components/AdminPanel/AdminPanel';

const ManagerPage = () => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <AdminPanel />
        </div>
    );
};

export default ManagerPage;